import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { PRODUCTS, EASE } from "@/lib/site";
import { trackClick } from "@/lib/track";

const LINKS = [["Science", "#science"], ["Ingredients", "#ingredients"], ["Ritual", "#ritual"], ["FAQ", "#faq"]];

export const Nav = ({ product = "joint-genesis", links = LINKS }) => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
    className="fixed inset-x-0 top-0 z-50"
    data-testid="site-nav"
  >
    <div className="mx-auto mt-3 flex max-w-7xl items-center justify-between rounded-full border border-[#F2EDE4]/10 bg-[#091D18]/70 px-4 py-2.5 backdrop-blur-xl sm:mx-6 lg:mx-auto lg:px-6 mx-3">
      <Logo />
      <nav className="hidden items-center gap-8 md:flex">
        {links.map(([label, href]) => (
          <a key={href} href={href} data-testid={`nav-link-${label.toLowerCase()}`} className="text-sm text-[#F2EDE4]/75 transition-colors hover:text-[#F2EDE4]">
            {label}
          </a>
        ))}
      </nav>
      {product ? (
      <a href={PRODUCTS[product].hoplink} target="_blank" rel="sponsored noopener noreferrer" data-testid="nav-cta-button" onClick={() => trackClick("nav", product)}
        className="rounded-full bg-[#F2EDE4] px-4 py-2 text-xs font-semibold text-[#091D18] transition-colors hover:bg-[#D96B43] sm:text-sm">
        Get {PRODUCTS[product].name}
      </a>
      ) : (
        <a href="#picks" data-testid="nav-cta-button" className="rounded-full bg-[#F2EDE4] px-4 py-2 text-xs font-semibold text-[#091D18] transition-colors hover:bg-[#D96B43] sm:text-sm">
          See the picks
        </a>
      )}
    </div>
  </motion.header>
);
